
import { computed, defineComponent } from "vue";

export default defineComponent({
  name: "name-initials",
  props: {
    name: {
      type: String,
      required: true,
    },
    size: {
      type: String,
      default: "small",
    },
  },
  setup(props) {
    const initialLetters = computed(() => {
      if (props.name === undefined) {
        return "";
      }

      const rgx = new RegExp(/(\p{L}{1})\p{L}+/, "gu");

      const initials = [...props.name.matchAll(rgx)] || [];

      var partOneLetter = "";
      var partTwoLetter = "";

      var partOne = initials.shift();
      if (partOne) {
        partOneLetter = partOne[1];
      }

      var partTwo = initials.pop();
      if (partTwo) {
        partTwoLetter = partTwo[1];
      }

      return (
        partOneLetter.toString() + partTwoLetter.toString()
      ).toUpperCase();
    });

    const sizeClass = computed(() => {
      if (props.size == "small") return "small";
      if (props.size == "normal") return "normal";
      if (props.size == "large") return "large";

      return "";
    });

    return { initialLetters, sizeClass };
  },
});
